import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=dcf088ec&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=dcf088ec&prod&scoped=true&lang=scss"
import style1 from "./layout.vue?vue&type=style&index=1&id=dcf088ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf088ec",
  null
  
)

export default component.exports